import React from 'react';
import TagManager from 'react-gtm-module';
import { createRoot } from 'react-dom/client';

import * as Sentry from '@sentry/react';

import { ENV } from './constants';
import { AuthService } from './modules/services/AuthService';
// import registerServiceWorker from './registerServiceWorker';
import AppRoot from './modules/AppRoot';

import './assets/styles/reset.css';

TagManager.initialize(ENV.GOOGLE_TAG_MANAGER);
AuthService.configure();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENV,
  enabled: process.env.REACT_APP_SENTRY_ENABLED === 'true',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.httpClientIntegration({
      failedRequestStatusCodes: [400, 401, 403, 404, 405, 429, 500, 502, 503, 504],
      failedRequestTargets: [/^((?!cognito).)*$/],
    }),
    Sentry.replayIntegration(),
    // Sentry.captureConsoleIntegration({ levels: ['error'] }),
  ],
  tracesSampleRate: 1, //  Capture 100% of the transactions
  // tracePropagationTargets: [/^https:\/\/freedom.fieldcontrolanalytics.com/],
  replaysSessionSampleRate: 0.1, // 0.1 default This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0, // 1.0 default If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<AppRoot />);

// registerServiceWorker();
